import useCleanup from 'utils/useCleanup';
import TabNav from 'components/global/TabNav';
import { $form, $view } from 'signals/global.signals';
import { Button, Col, Image, Row } from 'react-bootstrap';
import { handleShowModal } from 'components/global/_helpers/global.helpers';
import InviteUserModal from 'components/views/InvestorTeam/_components/InvestorInviteUserModal';
import { fetchAndSetUsersTeamsAndRoles } from 'components/views/InvestorTeam/_helpers/investorTeam.resolvers';
import useEffectAsync from 'utils/useEffectAsync';
import DefaultAvatar from 'components/global/DefaultAvatar';
import withDismount from 'hocs/withDismount';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faPaperPlane, faPlus } from '@fortawesome/free-solid-svg-icons';
import InvestorTeamCreateModal from 'components/views/InvestorTeam/_components/InvestorTeamCreateModal';
import InvestorTeams from './_components/InvestorTeams';
import InvestorPeople from './_components/InvestorPeople';
import InvestorInvites from './_components/InvestorInvites';

const InvestorTeam = () => {
  useEffectAsync(fetchAndSetUsersTeamsAndRoles);
  useCleanup([$view, $form]);

  return (
    <>
      <Row className="mb-24">
        <Col>
          <div className="d-flex flex-md-row flex-column align-items-center">
            <div
              className="d-flex justify-content-center rounded-circle flex-shrink-0 profileSettingsAvatar mb-md-0 mb-16"
            >
              {$view.value.logo
                ? <Image src={$view.value.logo} className="w-100 h-100" style={{ objectFit: 'cover' }} />
                : <DefaultAvatar name={$view.value.organizationName} styleArr={$view.value.logoColors} className="profileDefaultSettingsAvatar" />}
            </div>
            <div className="d-flex flex-column ms-md-32 ms-0 align-items-md-start align-items-center">
              <p className="m-0 h3 fw-600">
                {$view.value.organizationName}
              </p>
            </div>
          </div>
        </Col>
        <Col className="text-end">
          <Button
            variant="dark"
            onClick={() => handleShowModal('add-team')}
            className="text-white bg-dark me-16"
          >
            <FontAwesomeIcon icon={faPlus} className="me-8" />
            Add Team
          </Button>
          <Button
            variant="dark"
            onClick={() => handleShowModal('invite-user')}
            className="text-white bg-dark"
          >
            <FontAwesomeIcon icon={faPaperPlane} className="me-8" />
            Invite User
          </Button>
        </Col>
      </Row>
      <TabNav
        tabs={['Users', 'Teams', 'Pending Invites']}
        TabComponents={[<InvestorPeople />, <InvestorTeams />, <InvestorInvites />]}
        activeTab={$view.value.activeTab}
        async
      />
      <InviteUserModal />
      <InvestorTeamCreateModal />
    </>
  );
};

export default withDismount(InvestorTeam);
